import React from 'react';
import { connect } from '@cerebral/react';
import { useText } from 'common/hooks';

import { Wrapper, Title, SubText } from './elements';

export function Welcome(): React.ReactElement {
  const t = useText();

  return (
    <Wrapper>
      <Title id={'timeline-welcome-txt'}>
        {t('account.timeline.your_challenges')}
      </Title>
      <SubText>{t('account.timeline.cant_see')}</SubText>
    </Wrapper>
  );
}

export default connect(Welcome);
